<template>
  <div class="launch-settle-contianer">
    <div class="container">
      <div class="title">
        {{$t('申请提款')}}
      </div>
      <div class="sub-title">
        {{ $t('提款须知') }}
      </div>
      <div class="main">
        <div
          class="list-item"
          v-for="(item,index) in $t('WithdrawalInstructionsList')"
          :key="item.title"
        >
          <div class="list-title">
            {{ $t(item.title) }}
          </div>
          <div
            class="desc"
            v-for="desc in item.descList"
            :key="desc"
          >
            <span> • </span>{{ $t(desc) }}
          </div>

          <div
            v-if="index == 1"
            class="template-group"
          >
            <el-button
              class="btn"
              @click="handleClickTemplate('1')"
            >
              {{ $t('下载董事会决议模板') }}
              <img
                src="~@/assets/image/common/down.png"
                alt="down"
              >
            </el-button>
            <el-button
              class="btn"
              @click="handleClickTemplate('2')"
            >
              {{ $t('下载董事会决议示例') }}
              <img
                src="~@/assets/image/common/down.png"
                alt="down"
              >
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-group">
      <el-button
        type="primary"
        @click="handleNext"
      >{{ $t('下一步') }}</el-button>
    </div>
  </div>

</template>
<script>
export default {
  data () {
    return {
      list: [
        {
          title: '1、提款营业时间',
          descList: [
            '提现订单提交无时间限制（非工作日提款订单会推迟到下一个工作日处理）。'
          ]
        },
        {
          title: '2、提款收款人',
          descList: [
            '单股东企业，持股100%的股东。',
            '多股东企业，需要提供董事会决议指定一位股东作为提款收款人。'
          ]
        },
        {
          title: '3、提现银行账户',
          descList: [
            '提款收款人在中国大陆的个人银行账户。',
            '仅支持Ⅰ类银行账户（全功能账户），其他类别银行账户会由于超过收款限制会导致提现失败。'
          ]
        },
        {
          title: '4、手续费',
          descList: [
            '申请提款金额 * 0.3% /笔，最小收费金额15美金，不足15美金按15美金收取。'
          ]
        },
        {
          title: '5、提款限额',
          descList: [
            '最低申请提款金额100美元，最高申请提款金额50000美元。'
          ]
        },
        {
          title: '6、提款订单限制',
          descList: [
            '只支持提款180天内发生的汇入销售订单。（不含第180天）'
          ]
        },
        {
          title: '7、其他',
          descList: [
            '提款申请材料：出口商品/店铺网址、已发货提供本次贸易的全链物流单据（包含国内段物流信息和国际段物流信息）。',
            '如卖家、买家与发货人、收货人不一致，请提供双方关系证明，例如买家代付说明文件，卖家与发货人关于发货的说明等。'
          ]
        }
      ]
    }
  },
  methods: {
    handleClickTemplate (type) {
      console.log(process.env)
      if (+type === 1) {
        window.open(process.env.BASE_URL + 'download/Board Resolution-(Full name of corporation).pdf')
      } else {
        window.open(process.env.BASE_URL + 'download/Board Resolution-(XXXXXXXX LIMITED)-examples.pdf')
      }
    },
    handleNext () {
      this.$router.push({
        name: 'SettleStep'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.launch-settle-contianer {
  min-height: 712px;
  padding: 30px 30px 40px;
  color: @blackMore;

  .container {
    padding: 10px 10px 30px 10px;
    background: linear-gradient(
      180deg,
      rgba(251, 252, 254, 0) 0%,
      #f6f7fc 100%
    );
    border-radius: 10px;
    .title {
      font-size: 20px;
      line-height: 20px;
      font-weight: 500;
      font-family: PingFangSC-Medium, PingFang SC !important;
      line-height: 20px;
    }
    .sub-title {
      margin-top: 30px;
      font-size: 16px;
      font-weight: 300;
      line-height: 16px;
    }
    .main {
      padding: 30px 50px 0 30px;
      font-size: 14px;
      font-weight: 300;
      .list-item {
        color: @black;
        line-height: 24px;
        padding-bottom: 20px;
        .list-title {
          color: #323754;
        }
        .desc {
          margin: 0 0 0 23px;
          color: #586081;
          span {
            color: #a0a7c7;
          }
        }
        .template-group {
          margin: 20px 0 10px 23px;
          .btn {
            font-size: 14px;
            /deep/ span {
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
          img {
            width: 24px;
            height: 24px;
            margin-left: 10px;
          }
        }
      }
    }
  }
}
.btn-group {
  margin-top: 40px;
  // margin-left: 53px;
}
</style>
